// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.0.62/" + (chunkId === 4328 ? "klarna-test-drive-badge" : chunkId) + ".js";
};